import axios from '~/clients/axios';
import { SEARCH_V1_DELIVERY } from '~/constants/endpoints';
import type { DeliveryData } from '~/contracts/common/Geolocation';

export default function fetchSearchV1Delivery(
  zip5: string,
  offeringType?: 'new'
): Promise<DeliveryData> {
  const url = new URL(SEARCH_V1_DELIVERY);
  url.searchParams.set('Zip5', zip5);

  if (offeringType) {
    url.searchParams.set('OfferingType', offeringType);
  }

  return axios.get<DeliveryData>(url.toString()).then(res => res.data);
}
